import { useEffect } from 'react'

import { cachePolicies } from '../../../../src/lib/response-cache'
import { useTrackPageView } from '../../../app/_providers/TrackingProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { SeoMeta } from '../../../components/SeoMeta'
import { singleQueryParamValue } from '../../../lib/utils'
import { MagnoliaPage } from '../MagnoliaApp'

import { AftershipIframe } from './styles'

const resizeIframe = (event: MessageEvent) => {
  const iframe = document.querySelector(AftershipIframe.toString()) as HTMLElement
  if (iframe && event.data?.type === 'resize' && typeof event.data.scrollHeight === 'number') {
    iframe.style.height = event.data.scrollHeight + 'px'
  }
}

export const TrackingPage: MagnoliaPage<{ trackingNumber: string }> = ({ trackingNumber }) => {
  const {
    magnolia: {
      account: { trackOrder },
    },
  } = useTranslation()
  useTrackPageView({ pageViewHandle: 'Order Tracking', pageViewCategory: 'other' })

  useEffect(() => {
    window.addEventListener('message', resizeIframe)
    return () => window.removeEventListener('message', resizeIframe)
  }, [])

  return (
    <>
      <SeoMeta title={trackOrder} />
      <AftershipIframe
        scrolling='no'
        src={`https://wearfigs.aftership.com/iframe/${trackingNumber}`}
      />
    </>
  )
}

TrackingPage.getInitialProps = function (pageContext) {
  const trackingNumber: string = singleQueryParamValue(pageContext.query.trackingNumber, '')

  return {
    trackingNumber,
    responseCacheControl: cachePolicies.noCache,
  }
}
